"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const BaseProposition_1 = tslib_1.__importDefault(require("./BaseProposition"));
const PropositionProduct_1 = tslib_1.__importDefault(require("./PropositionProduct"));
const PropositionAttribute_1 = tslib_1.__importDefault(require("./PropositionAttribute"));
class GetPropositionResponse extends BaseProposition_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: 'psv-1-jaar-vast-cdt70015',
        description: `It is used for fetching/updating/deleting propositions created by you.<br>
    By combining it with the owner field, which is extracted from the x-api-key, it forms a unique identifier.<br>
    It can be anything, as long as it gives meaning to you for the resource you are creating/updating/deleting.`,
    }),
    tslib_1.__metadata("design:type", String)
], GetPropositionResponse.prototype, "reference", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, base_models_1.Docs)({
        example: ['62066-3-jaar-lang-dalend-stroom', '57803-psv-tegoedbon-105-euro'],
        description: 'Array of incentive references.',
    }),
    tslib_1.__metadata("design:type", Array)
], GetPropositionResponse.prototype, "incentiveReferences", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => PropositionAttribute_1.default),
    tslib_1.__metadata("design:type", Array)
], GetPropositionResponse.prototype, "attributes", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => PropositionProduct_1.default),
    tslib_1.__metadata("design:type", Array)
], GetPropositionResponse.prototype, "products", void 0);
exports.default = GetPropositionResponse;
